module.exports = {"version":"0.559.0"}


//////////////////
// WEBPACK FOOTER
// ./packages/web-app/build-tools/public/meta.json
// module id = 3872
// module chunks = 0